export enum Color {
    DEFAULT = 'default',
    SECONDARY = 'secondary'
}